// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8752d331","455":"ce71067c","977":"a5562e50"}[chunkId] + ".chunk.js";
};